export interface StatusStyle {
  backgroundColor: string;
  text: string;
  textColor: string;
}

export type ChannelStatus = 'in conversation' | 'in_conversation' | 'pending' | 'active' | 'guide finder active' | 'inactive' | string;

export const getStatusStyles = (status: ChannelStatus): StatusStyle => {
  switch (status?.toLowerCase()) {
    // The backend writes 'in conversation' (with a space); the underscore
    // variant is kept for tolerance.
    case 'in conversation':
    case 'in_conversation':
      return { backgroundColor: '#7B61FF', text: 'IN CONVERSATION WITH ANOTHER GUIDE', textColor: '#FFF' };
    case 'pending':
      return { backgroundColor: '#FFD700', text: 'PENDING', textColor: '#000' };
    case 'active':
      return { backgroundColor: '#4CAF50', text: 'ACTIVE', textColor: '#FFF' };
    // WaConversations::GUIDE_FINDER_ACTIVE — the backend keeps this value
    // untranslated on the channel so the app can tell a Guide Finder chat
    // apart from an ordinary active one.
    case 'guide finder active':
      return { backgroundColor: '#4CAF50', text: 'ACTIVE FROM GUIDE FINDER', textColor: '#FFF' };
    case 'inactive':
    default:
      return { backgroundColor: '#D3D3D3', text: 'INACTIVE', textColor: '#000' };
  }
};
